'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import React from 'react';
export const LeaderBoardHeader = () => {
  const $ = _c(11);
  const t = useTranslations("LeaderBoard.Header");
  let t0;
  if ($[0] !== t) {
    t0 = t("Competition");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <div className="mb-0.5 md:mb-0 text-[#FFFFFF] font-secondary text-[16px] font-bold 2md:[32px] lg:text-[42px] leading-[1.1]">{t0}</div>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t) {
    t2 = t("Title");
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <div className="text-fill-transparent mb-0 bg-gradient-to-r from-[#DA3D15] to-[#FE7801] bg-clip-text font-secondary text-hero font-bold 2md:text-hero-2md lg:text-hero-lg">{t2}</div>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t3) {
    t4 = <h1 className="flex flex-col justify-center text-center text-white">{t1}{t3}</h1>;
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};